"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const openapi_1 = require("../../../../../openapi");
const Consumable = __importStar(require("../consumable/schema"));
const Location = __importStar(require("../location/schema"));
const Log = __importStar(require("../log/schema"));
const Ota = __importStar(require("../ota/schema"));
const Stats = __importStar(require("../stats/schema"));
const schema_1 = require("./schema");
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Device.ServiceMenu.Spec';
/**
 * The router guard is `AuthenticatedDeviceRouteGuard`. It answers a v1 body:
 * 401 `INVALID_TOKEN`, or 403 `NOT_ALLOWED` when the session is not a device session.
 * `Security.V1DeviceCertificate` documents that. The rate limiter is a no-op, so 429 is omitted.
 *
 * `getDevice()` throws `NOT_ALLOWED` when the device cannot be loaded.
 * A handler that passes that error to `buildErrorResponseFromMessage` answers 403.
 * A handler that returns `buildNotAuthenticatedResponse` answers 401 instead.
 * An uncaught rejection is 500.
 */
const MALFORMED_JSON = 'Malformed JSON is the Express default HTML 400: express.json() is attached on the route, ' +
    'and the JSON error handler runs before the routes.';
const Empty = openapi_1.Response.EmptyData.annotations({
    description: 'v1 success with data: {}',
});
const getInstalled = platform_1.HttpApiEndpoint.get('getInstalledConsumables') `/consumables/installed`
    .addSuccess(openapi_1.Response.Success(Consumable.Installed))
    .addError(Consumable.Pelican2Only)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get installed consumables')
    .annotate(platform_1.OpenApi.Description, 'Returns the Pelican2 slots in the legacy shape. When the document does not decode, ' +
    'a Pelican2 model is 500 and any other model is 422 INVALID_REQUEST, with detail naming ' +
    'that model. A MicroPurityFilter in slot 9 has no legacy mapping, so that device is 500. ' +
    'A session failure is an uncaught rejection, so it is 500.');
const getCatalogue = platform_1.HttpApiEndpoint.get('getConsumableCatalogue') `/consumables/catalogue`
    .addSuccess(openapi_1.Response.Success(Consumable.Catalogue))
    .addError(openapi_1.Error.Internal)
    .annotate(platform_1.OpenApi.Title, 'Get consumable catalogue')
    .annotate(platform_1.OpenApi.Description, 'Returns the v2 catalogue for the model on the session device. ' +
    'This is not the legacy catalog. A session failure, a device that does not decode, ' +
    'or a catalogue that does not encode is 500. There is no 422.');
const getCatalog = platform_1.HttpApiEndpoint.get('getConsumableCatalog') `/consumables/catalog`
    .addSuccess(openapi_1.Response.Success(Consumable.Catalog))
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get consumable catalog')
    .annotate(platform_1.OpenApi.Description, 'Returns the legacy catalog. The query is ignored, and the list is not filtered by the ' +
    'device model. Six tags are kept: LiquidEnhancement, PreCarbonBlockFilter, ' +
    'CarbonBlockFilter, LimescaleFilter, UVCLight and CO2Tank. There is no validation error.');
const getEvents = platform_1.HttpApiEndpoint.get('getDeviceEvents') `/log/events`
    .addSuccess(openapi_1.Response.Success(Log.Events))
    .addError(openapi_1.Error.V1Forbidden)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get device events')
    .annotate(platform_1.OpenApi.Description, 'Returns stored history events for the session device. The window is createdAt from 30 days ' +
    'before now through now. The body is { items: rows }, and Cosmos system fields are removed. ' +
    'A device that cannot be loaded is 403 NOT_ALLOWED. Any other failure in the catch is 500.');
const getAlarms = platform_1.HttpApiEndpoint.get('getDeviceAlarms') `/log/alarms`
    .addSuccess(openapi_1.Response.Success(Log.Alarms))
    .addError(openapi_1.Error.V1Forbidden)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get device alarms')
    .annotate(platform_1.OpenApi.Description, 'Returns the alarm page for the last 30 days, at most 100 rows, including orphans. ' +
    'data.items is that page ({ itemsCount, pagesCount, page, items }), not the row array. ' +
    'Each row is the stored alarm: name and params, not a nested alarm. ' +
    'A device that cannot be loaded is 403 NOT_ALLOWED. Any other failure in the catch is 500.');
const getErrors = platform_1.HttpApiEndpoint.get('getDeviceErrors') `/log/errors`
    .addSuccess(openapi_1.Response.Success(Log.Errors))
    .addError(openapi_1.Error.V1Forbidden)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get device errors')
    .annotate(platform_1.OpenApi.Description, 'Returns stored history errors for the session device. The window matches the events log: ' +
    'createdAt from 30 days before now through now. The handler does not filter on ' +
    'dismissed. The body is { items: rows }, and Cosmos system fields are removed. ' +
    'A device that cannot be loaded is 403 NOT_ALLOWED. Any other failure in the catch is 500.');
const patchConsumable = platform_1.HttpApiEndpoint.patch('patchConsumable') `/consumable`
    .setPayload(Consumable.PatchBody)
    .addSuccess(openapi_1.Response.Success(Consumable.InstalledList))
    .addError(Consumable.PatchRejected)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Update consumables')
    .annotate(platform_1.OpenApi.Description, 'Updates Pelican2 slots from one instruction or an array of them. A body that parses but ' +
    'does not decode is 400 BAD_REQUEST with validationErrors. The success body is the ' +
    'legacy slot list, not wrapped in items. The device is saved before that list is built. ' +
    'A MicroPurityFilter in slot 9 has no legacy mapping, so the mapper throws after the ' +
    'save: the client gets 500 and the write is already stored. An unknown subsetId, or a ' +
    'subset whose tag the slot does not accept, throws during the slot update, before the ' +
    'save, so nothing is stored. A device that is not a Pelican2, or a session failure, ' +
    'rejects the promise before the save and is 500. ' +
    MALFORMED_JSON)
    .pipe(openapi_1.Annotations.deprecated());
const patchMetadata = platform_1.HttpApiEndpoint.patch('patchMetadata') `/registry/metadata`
    .setPayload(schema_1.MetadataUpdate)
    .addSuccess(Empty)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthenticated)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Update device metadata')
    .annotate(platform_1.OpenApi.Description, 'Stores the metadata items for the session device. items must be a non-empty array and ' +
    'each key a non-empty string. value is required: an item without it is 422, and any JSON ' +
    'value is accepted. inputValidation paths are relative to the item (`key`, `value`), not ' +
    'items[n].key. A missing session is 401. A repository failure is 500. The success body ' +
    'is data: {}. ' +
    MALFORMED_JSON);
const patchAddress = platform_1.HttpApiEndpoint.patch('patchInstallationAddress') `/location/address`
    .setPayload(Location.Address)
    .addSuccess(Empty)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthenticated)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Update installation address')
    .annotate(platform_1.OpenApi.Description, 'Updates the installation address of the session device. lat and lon are both kept only ' +
    'when both are sent. If either is missing, formatLatLon fills both from the address and ' +
    'overwrites the one that was sent. A failed lookup is swallowed and both are set to null; ' +
    'it is not 500. update() then skips a null or zero coordinate, because the check is if (lat) and if (lon), and an omitted or empty address or ' +
    'contact field keeps the stored value. mobilePhoneNumber is written into phoneNumber when ' +
    'phoneNumber is omitted. A supplied customerAccountId is spread into numeric keys and is ' +
    'not stored under that name, because || is evaluated before the object that would store it. ' +
    'The request still returns 200, and that contactInfo replaces the stored one, so a ' +
    'previously stored account id is lost. ' +
    'update() sets providedLocation from the session device, ' +
    'or to {} when that device has none. The session device is the raw session record. A parsed ' +
    'body that fails isFloat or isString is 422. A missing session is 401. A registry failure ' +
    'is 500. ' +
    MALFORMED_JSON);
const patchCellTower = platform_1.HttpApiEndpoint.patch('patchCellTower') `/location/cell-tower`
    .setPayload(Location.CellTowerRequest)
    .addSuccess(Empty)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotAuthenticated)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Update cell tower location')
    .annotate(platform_1.OpenApi.Description, 'Writes detectedLocation from cellTowerInfo and returns data: {}. notEmpty() stringifies ' +
    'an object, so {} passes and is forwarded. The stored value is ' +
    '{ lat, lon, accuracy, source: "CELL" }: numbers when Google returns a fix, and null ' +
    'for all three when the lookup fails, including the empty object. The lookup failure is ' +
    'still 200. Either shape uses source, and the domain detected location expects tech, so ' +
    'a later V2 read of that device is 500 and a list query drops it. A missing cellTowerInfo ' +
    'or a value that is not an object is 422. A missing session is 401. A registry write ' +
    'failure is 500. ' +
    MALFORMED_JSON);
const factoryReset = platform_1.HttpApiEndpoint.post('factoryReset') `/registry/factory-reset`
    .addSuccess(Empty)
    .addError(openapi_1.Error.V1NotAuthenticated)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Factory reset')
    .annotate(platform_1.OpenApi.Description, 'Resets the session device to factory settings and dismisses open alarms. There is no ' +
    'body. A missing session is 401. A failed reset is 500. The success body is data: {}.');
const getOtaList = platform_1.HttpApiEndpoint.get('getOtaBuilds') `/ota/list`
    .addSuccess(openapi_1.Response.Success(Ota.Builds))
    .addError(openapi_1.Error.NotAuthenticated)
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.Internal)
    .annotate(platform_1.OpenApi.Title, 'List OTA builds')
    .annotate(platform_1.OpenApi.Description, 'Returns the OTA builds for the session device model, as a v2 body { builds }. ' +
    'A missing session is the v2 401, which is separate from the guard. A session device that ' +
    'does not decode is the v2 400. A build row that does not decode is logged and dropped, ' +
    'and the response is 200 with the rows that remain. A query or encode failure is 500.');
const postOtaJob = platform_1.HttpApiEndpoint.post('createOtaJob') `/ota/job`
    .setPayload(Ota.JobRequest)
    .addSuccess(Empty)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(Ota.InvalidBuildFile)
    .addError(Ota.InvalidSerialNumber)
    .addError(Ota.InvalidBuildType)
    .addError(openapi_1.Error.V1NotAuthenticated)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Create OTA job')
    .annotate(platform_1.OpenApi.Description, 'Creates one OTA job for the session device and returns data: {}. The job id is ' +
    '`${device.id}-SVM-${Date.now()}` and is not in the body. An omitted maxAttempts is ' +
    'stored as 50, an omitted retryInterval as 1800, and omitted notificationTriggers as []. ' +
    'maxAttempts and retryInterval may be a number or an integer string. A string with spaces, a decimal point or an exponent is 422. A parsed body that ' +
    'fails validation is 422 INVALID_REQUEST with inputValidation. Any failure of the build ' +
    'lookup, including a database or decode error, is 422 INVALID_BUILD_FILE, and the caught ' +
    'value is spread onto that error body. A serial that encodes no model is 422 ' +
    'INVALID_SERIAL_NUMBER. A build for another model is 422 INVALID_BUILD_TYPE with ' +
    'build.model and build.deviceModel. A missing session is 401. A failed job write is 500. ' +
    MALFORMED_JSON);
const getStats = platform_1.HttpApiEndpoint.get('getEnhancedDrinkStats') `/stats`
    .addSuccess(openapi_1.Response.Success(Stats.EnhancedDrinks))
    .addError(openapi_1.Error.V1Forbidden)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Get enhanced drink stats')
    .annotate(platform_1.OpenApi.Description, 'Returns how many drinkDispensed events had comp.enhanced set, and a count per subset id. ' +
    'The subset count is the number of entries in params.enhancements, so one event can add ' +
    'more than one, and an entry without subsetId is counted as "undefined". The counts are ' +
    'data itself, not data.items. A device that cannot be loaded is 403 NOT_ALLOWED. An event ' +
    'with no params, or any other failure in the catch, is 500.');
const migrate = platform_1.HttpApiEndpoint.post('migrateConsumables') `/consumables/migrate`
    .setPayload(Consumable.PatchBody)
    .addSuccess(openapi_1.Response.Success(Consumable.MigratedConsumables))
    .addError(Consumable.PatchRejected)
    .addError(openapi_1.Error.V1Internal)
    .annotate(platform_1.OpenApi.Title, 'Migrate consumables')
    .annotate(platform_1.OpenApi.Description, 'Runs the same slot instructions as the consumable patch and returns the encoded Pelican2 ' +
    'consumables. Nothing is saved: unlike the patch, this handler does not call ' +
    'deviceRepo.save. The array is data itself, not the legacy slot list. A body that parses ' +
    'but does not decode is 400 BAD_REQUEST with validationErrors. A device that is not a ' +
    'Pelican2, or a session failure, is 500. ' +
    MALFORMED_JSON);
exports.Spec = platform_1.HttpApiGroup.make('v2.device.service-menu')
    .middleware(openapi_1.Security.V1DeviceCertificate)
    .add(getInstalled)
    .add(getCatalogue)
    .add(getCatalog)
    .add(getEvents)
    .add(getAlarms)
    .add(getErrors)
    .add(patchConsumable)
    .add(patchMetadata)
    .add(patchAddress)
    .add(patchCellTower)
    .add(factoryReset)
    .add(getOtaList)
    .add(postOtaJob)
    .add(getStats)
    .add(migrate)
    .prefix('/device/service-menu')
    .annotate(platform_1.OpenApi.Title, 'Device service menu')
    .annotate(platform_1.OpenApi.Description, 'On-board service menu for the device identified by its certificate.')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Device));
//# sourceMappingURL=spec.js.map